<template>
  <div>
    <validation-observer
      :id="`${itemName}-edit`"
      v-slot="claimAndConvictionObserver"
      class="subform-wrapper"
      slim
    >
      <form-section-highlight>
        <form-row :label="label" />
        <form-row>
          <component
            :is="question.questionComponent"
            v-for="question in questions"
            :id="question.questionId"
            :key="question.questionId"
            class="subform-style"
            :step-id="`${stepId}.${uniqueId}`"
            :question-id="question.questionId"
            v-bind="question.params || {}"
            :form-observer="formObserver"
            step-type="multiple"
            :step-index="stepIndex"
            :form-data="item"
            :step-data="claimAndConvictionToEdit"
            @input="claimAndConvictionToEdit[question.params.customFields.field] = $event[question.params.customFields.field] "
          />
        </form-row>
        <form-row>
          <qz-btn
            color="navy-light"
            rounded
            x-large
            dark
            :data-test="`save_${itemName}_btn`"
            @click.prevent="save(claimAndConvictionObserver)"
          >
            Save {{ itemName }} details
            <v-icon
              dark
              right
              size="22"
            >
              mdi-content-save
            </v-icon>
          </qz-btn>
          <qz-btn
            color="primary"
            text
            rounded
            class="ml-2"
            x-large
            :data-test="`cancel_${itemName}_btn`"
            @click.prevent="$emit('clear')"
          >
            Cancel
            <template v-if="isEdit">edit</template>
          </qz-btn>
        </form-row>
      </form-section-highlight>
    </validation-observer>
    <!-- HIDDEN FIELD TO CHECK EDITOR NOT OPENED -->

    <validation-provider
      v-slot="{ failed }"
      :name="`New ${uniqueId}`"
      :vid="`${stepId}_${sectionItemName}-new`"
      :rules="{ is_not: { other: true } }"
    >
      <input
        :value="formOpen"
        type="hidden"
      >
      <div
        v-if="failed && formObserver.validated"
        class="error--text text-body-1 mt-4"
      >
        You have unsaved {{ itemName }} details. Please save or cancel these details before continuing.
      </div>
    </validation-provider>
  </div>
</template>

<script>
import { cloneDeep, capitalize } from 'lodash';
import useSubformValidation from '@/composables/useSubformValidation';

export default {
  name: 'form-claim-and-conviction',
  props: {
    index: {
      type: Number,
      default: null,
    },
    uniqueId: {
      type: String,
      default: 'claims',
    },
    itemName: {
      type: String,
      default: 'claim',
    },
    item: {
      type: Object,
      required: true,
    },
    formObserver: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    stepId: {
      type: String,
      default: 'drivers',
    },
    stepIndex: {
      type: Number,
      default: 0,
    },
    sectionItemName: {
      type: String,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
  inject: [
    'helpers',
  ],
  data () {
    return {
      formOpen: false,
      claimAndConvictionToEdit: cloneDeep(this.item),
    };
  },
  computed: {
    label () {
      return this.helpers.getSubformLabel(capitalize(this.itemName), this.isEdit, this.index);
    },
  },
  async mounted () {
    this.formOpen = true;
  },
  methods: {
    async save (observer) {
      const questionIds = this.questions.map(item => item.questionId);

      await this.saveSubform({
        observer,
        subformType: this.itemName,
        quoteData: this.claimAndConvictionToEdit,
        questionIds,
      });
    },
  },
  setup (props, context) {
    return {
      // composable
      ...useSubformValidation(null, context),
    };
  },
};
</script>
<style lang="scss" src='@/assets/scss/subform/subform.scss'></style>
<style lang="scss" scoped>
  .form-row {
    &::v-deep {
      .form-section:first-of-type .form-section__container {
        padding: 0;
      }

      .form-section__validity {
        display: none;
      }
    }
  }
</style>
